import { render } from "./ApplianceItem.vue?vue&type=template&id=68c3796b&scoped=true&ts=true"
import script from "./ApplianceItem.vue?vue&type=script&lang=ts"
export * from "./ApplianceItem.vue?vue&type=script&lang=ts"

import "./ApplianceItem.vue?vue&type=style&index=0&id=68c3796b&lang=scss&scoped=true"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68c3796b"]])

export default __exports__